import { render, staticRenderFns } from "./LoginPanel.vue?vue&type=template&id=1820cdd2&scoped=true&"
import script from "./LoginPanel.vue?vue&type=script&lang=js&"
export * from "./LoginPanel.vue?vue&type=script&lang=js&"
import style0 from "./LoginPanel.vue?vue&type=style&index=0&id=1820cdd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820cdd2",
  null
  
)

export default component.exports